"use client";

import React from 'react';

export default function PromoBanner() {
  const scrollToContact = () => {
    const el = document.getElementById('kontakt');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="max-w-screen-2xl mx-auto px-8 py-8">
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-3xl p-10 md:p-14 text-center text-white">
        <div className="max-w-2xl mx-auto">
          <div className="inline-block px-4 py-1 rounded-full bg-white/20 text-sm font-medium mb-4">
            PROMOCJA NA START
          </div>
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tighter mb-4">
            Darmowa wycena + konfiguracja aplikacji mobilnej
          </h2>
          <p className="text-blue-100 mb-8 text-lg">
            Przy zamówieniu systemu monitoringu do końca miesiąca przygotujemy indywidualną ofertę 
            i skonfigurujemy aplikację na telefonie całkowicie bezpłatnie.
          </p>
          <button 
            onClick={scrollToContact}
            className="px-8 py-4 bg-white text-blue-700 font-semibold rounded-3xl hover:bg-zinc-100 active:bg-white transition-colors"
          >
            Skorzystaj z promocji
          </button>
        </div>
      </div>
    </section>
  );
}
